module.exports = __webpack_public_path__ + "img/SMT_45_Ms_Liao_Weifen.dcff9a98.jpg";